export const environment = {
  production: false,
  apiUrl: 'https://hci-dev.kozaca.com.ar/api',
  apiUrl_photo: 'https://hci-dev.kozaca.com.ar',

  x_api_key: '8F4UPAvwlse8b5wIVaY95Ljlca5eiXD5asd4',

  // Auth (NO hardcodear en servicios)
  auth: {
    clientId: '019a5f79-0465-7330-8f4b-dc2ae7fdc59c',
    clientSecret: 'HV0Vv3TDmJYJNv9WXxH264mab0GeUV71ZH0pZIfF',
  },
};
